import EditorVMBase from "../../../../Lib/Fs.SmartClient.Client/EditorVMBase";
import { ValidationRules, ValidationController, validateTrigger } from "aurelia-validation";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import { useView, autoinject, Container, computedFrom } from 'aurelia-framework';
import { Router } from 'aurelia-router'
import UserData01 from "../../../Core/Scripts/AppServiceContract/UserData01";
import GroupUpdateRequest from "../../../Core/Scripts/AppServiceContract/GroupUpdateRequest";
import ManageUserGroupAppService from "../../Scripts/AppServiceContract/ManageUserGroupAppService";
import { fs } from "../../../../Config/FsConfig";

@autoinject
export default class InformationEditorVM extends EditorVMBase {
    Code: string;
    Name: string;
    IsActive: boolean;
    IsCreate: boolean;
    IsEditMode: boolean;
    Id: string;
    Router: Router;

    constructor(id) {
        super();
        var self = this;
        this.Router = Container.instance.get(Router);
        self.IsActive = false;

        ValidationRules
            .ensure('Code').required().withMessage('Code is required.')
            .ensure('Name').required().withMessage('Name is required.')
            .on(this);

        this.IsCreate = true;
        self.Id = id;
        self.Load(id);
    }

    Load(id: string) {
        var self = this;
        if (id != null && id != 'undefined') {
            self.LoadData();
            self.IsCreate = false;
            self.IsEditMode = true;
        } else {
            this.BeginEdit();
        }
    };

    LoadOriginalSource(originalSource: UserData01) {
        this.Code = originalSource.Code;
        this.Name = originalSource.Name;
        this.IsActive = originalSource.IsActive;
        this.HasOriginalSource = true;
    }

    SaveOriginalSource(originalSource: UserData01) {
        originalSource.Code = $.trim(this.Code);
        originalSource.Name = $.trim(this.Name);
        originalSource.IsActive = this.IsActive;
    }

    SaveData() {
        var self = this;
        self.validationController.validate({ object: self }).then(result => {
            if (result.valid) {
                this.Save(null, null);
            }
        });
        ;
    }

    Save(doneCallback: () => void, failCallback: (error) => void) {
        var self = this;

        var request = this.CreateRequest();

        var service = Container.instance.get(ManageUserGroupAppService) as ManageUserGroupAppService;
        if (this.HasOriginalSource) {
            service.Update(request)
                .done((result) => {
                    FsUtility.AlertModal("The item has been updated successfully", 2, 1);
                    if (doneCallback != null) {
                        doneCallback();
                    }
                }).fail(FsUtility.CommonErrorHandler);
        } else {
            service.Add(request)
                .done((result) => {
                    if (self.IsCreate) {
                        FsUtility.AlertModal("The item has been saved successfully", 2, 1, function (click) {
                            if (click == true) {
                            /*self.Router.navigateToRoute("UserGroupEdit", { id: encode });*/
                              window.location.href = fs.Config.UserGroupDetailUrl + result;
                            }
                        });
                    }
                }).fail(FsUtility.CommonErrorHandler);
        }
        this.EndEdit();
    }

    LoadData() {
        var self = this;
        var service = Container.instance.get(ManageUserGroupAppService) as ManageUserGroupAppService;
        service.Load(self.Id)
            .done((result) => {
                self.SetOriginalSource(result);
            }).fail(FsUtility.CommonErrorHandler);
    }

    CreateRequest(): GroupUpdateRequest {
        var request = new GroupUpdateRequest();
        request.Code = $.trim(this.Code);
        request.Name = $.trim(this.Name);
        request.IsActive = this.IsActive;
        request.userUID = this.Id;
        return request;
    }

    Cancel() {
        var self = this;
        if (self.IsCreate)
            window.location.href = fs.Config.ClientBaseUrl + "#/Modules/Core/ManageUserGroupPage";
        else {
            this.EndEdit();
            if (this.HasOriginalSource)
                this.LoadOriginalSource(this.OriginalSource);
        }
    }

    @computedFrom('validationController.errors.length', 'Code')
    get CodeErrors() {
        return this.getValidateErrors('Code');
    }

    @computedFrom('validationController.errors.length', 'Name')
    get NameErrors() {
        return this.getValidateErrors('Name');
    }
}
